import { createContext } from "react";

/** Route-owned sidebar content mounts inside the persistent application sidebar. */
export const SidebarContentSlot = createContext<HTMLDivElement | null>(null);
